import { TrackingPageModel } from '../tracking-page.model';
import {
  getAsset,
  getAppImage,
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white,
  getProductItems
} from './helpers';

export const vintage: TrackingPageModel = {
  languageMenu: getLanguageMenu('Roboto', '#1b1e2fff'),
  searchPageInput: {
    backgroundColor: white,
    shadow: 'none',
    borderColor: '#ced4da',
    borderWidth: 1,
    borderRadius: 4,
    ...getFontConfig('Roboto', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 18,
    ...getFontConfig('Roboto', '#1b1e2fff')
  },
  background: {
    color: '#faf9f7ff',
    useBackgroundImage: false,
    imageUrl: getAppImage('/assets/img/tracking-page/Img_map_white.png'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    linksColor: '#d77e6aff',
    linksUnderline: false,
    backgroundColor: white,
    headerBackground: white,
    footerBackground: white,
    borderColor: '#1b1e2f33',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Roboto', '#1b1e2fff')
  },
  orderCard: {
    borderRadius: 2,
    borderWidth: 1,
    borderColor: '#d5d9e1',
    backgroundColor: white,
    shadow: 'none',
    footerBackground: white,
    headerBackground: white,
    linksColor: '#d77e6aff',
    linksUnderline: false,
    ...getFontConfig('Roboto', '#1b1e2fff')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Noto Sans KR', '#1b1e2fff')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 17,
    ...getFontConfig('Roboto Condensed', '#1b1e2fff')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Roboto', '#989898ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 13,
    ...getFontConfig('Roboto Mono', '#e74115ff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    shadow: 'none',
    borderColor: '#d5d9e1',
    borderRadius: 2,
    borderWidth: 1,
    backgroundColor: '#ffffff',
    button: {
      on: true,
      backgroundColor: '#d77e6aff',
      borderColor: '#d77e6aff',
      borderRadius: 2,
      borderWidth: 1,
      shadow: 'none',
      ...getFontConfig('Roboto', '#ffffffff')
    },
    itemsLimit: 4,
    scroll: false,
    itemCard: {
      backgroundColor: white,
      borderColor: '#d5d9e1',
      borderRadius: 2,
      borderWidth: 1,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 20,
        ...getFontConfig('Roboto', '#1b1e2fff', '700')
      },
      info: {
        alignment: 'left',
        fontSize: 14,
        ...getFontConfig('Roboto', '#909090ff')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#00ccff00',
    borderColor: '#d77e6aff',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Roboto', '#d77e6aff')
  },
  detailsButton: {
    on: null,
    backgroundColor: '#d77e6aff',
    borderColor: '#00ccff00',
    borderRadius: 2,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto', white)
  },
  trackButton: {
    on: null,
    backgroundColor: '#d77e6aff',
    borderColor: '#ee7227',
    borderRadius: 2,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto', white)
  },
  pageScroll: {
    scrollColor: '#00000033',
    borderRadius: 4,
    backgroundColor: '#00ccff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/5c98dad9b347f_vintagelogo-360x.png')),
  socialIcons: getSocialIcons('#d77e6aff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: white,
    borderColor: '#1b1e2f33',
    borderRadius: 2,
    borderWidth: 1,
    sidebarField: 'orderNumbers',
    shadow: 'none',
    ...getFontConfig('Roboto', '#1b1e2fff')
  },
  footer: {
    linksColor: '#d77e6aff',
    linksUnderline: false,
    backgroundColor: '#faf9f7ff',
    ...getFooterItems(),
    ...getFontConfig('Roboto', '#1B1E2F')
  },
  header: {
    backgroundColor: '#faf9f7ff'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  defaultThemeId: 'vintage',
  sidebarProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#1b1e2f33',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#1b1e2f33',
      borderRadius: 2,
      borderWidth: 0,
      shadow: 'none',
      button: {
        on: null,
        backgroundColor: '#d77e6aff',
        borderColor: '#00ccff00',
        borderRadius: 2,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Roboto', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 20,
        ...getFontConfig('Roboto Condensed', '#1b1e2fff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Roboto', '#1b1e2fff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 16,
        ...getFontConfig('Roboto Condensed', '#1b1e2fff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('sidebar'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#d77e6aff',
      arrowSize: 24
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: white,
    borderColor: '#1b1e2f33',
    borderRadius: 2,
    borderWidth: 1,
    shadow: 'none',
    card: {
      backgroundColor: white,
      borderColor: '#1b1e2f33',
      borderRadius: 2,
      borderWidth: 0,
      shadow: 'none',
      button: {
        on: null,
        backgroundColor: '#d77e6aff',
        borderColor: '#00ccff00',
        borderRadius: 2,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Roboto', white)
      },
      buttonText: 'Buy Now',
      title: {
        alignment: 'center',
        fontSize: 11,
        ...getFontConfig('Roboto', '#1b1e2fff')
      },
      regularPrice: {
        alignment: 'center',
        fontSize: 10,
        ...getFontConfig('Roboto', '#1b1e2fff')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 12,
        ...getFontConfig('Roboto', '#1b1e2fff')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('main'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#d77e6aff',
      arrowSize: 24
    }
  },
  seoTitle: ''
};
